/* eslint-disable */
import React from "react";
import {NavLink, useLocation} from "react-router-dom";
// chakra imports
import {Box, Flex, HStack, Text, useColorModeValue, Tooltip} from "@chakra-ui/react";

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("#f6ad55", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("#f6ad55", "white");
  let textColor = useColorModeValue("white", "white");
  let brandColor = useColorModeValue("#f6ad55", "white");

  const { routes, isCollapsed } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <>
            {!isCollapsed && (
              <Text
                fontSize={"md"}
                color={activeColor}
                fontWeight="bold"
                mx="auto"
                ps={{
                  sm: "10px",
                  xl: "16px",
                }}
                pt="18px"
                pb="12px"
                key={index}
              >
                {route.name}
              </Text>
            )}
            {createLinks(route.items)}
          </>
        );
      } else if (route.layout === "/dashboard" || route.layout === "/auth") {
        return (
          <NavLink to={route.layout + route.path}>
            {route.icon ? (
              <Box>
                {isCollapsed ? (
                  // Collapsed view - icon only with tooltip
                  <Tooltip
                    label={route.name}
                    placement="right"
                    hasArrow
                    bg="gray.700"
                    color="white"
                    fontSize="sm"
                    px={3}
                    py={2}
                    borderRadius="md"
                  >
                    <Flex
                      alignItems="center"
                      justifyContent="center"
                      py="10px"
                      mx="auto"
                      w="40px"
                      h="40px"
                      borderRadius="8px"
                      bg={
                        activeRoute(route.path.toLowerCase())
                          ? "rgba(246, 173, 85, 0.2)"
                          : "transparent"
                      }
                      _hover={{
                        bg: "rgba(255, 255, 255, 0.1)"
                      }}
                    >
                      <Box
                        color={
                          activeRoute(route.path.toLowerCase())
                            ? activeIcon
                            : textColor
                        }
                      >
                        {route.icon}
                      </Box>
                    </Flex>
                  </Tooltip>
                ) : (
                  // Expanded view - icon and text
                  <HStack
                    spacing={
                      activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                    }
                    py="5px"
                    ps="10px"
                  >
                    <Flex w="100%" alignItems="center" justifyContent="center">
                      <Box
                        color={
                          activeRoute(route.path.toLowerCase())
                            ? activeIcon
                            : textColor
                        }
                        me="18px"
                      >
                        {route.icon}
                      </Box>
                      <Text
                        me="auto"
                        color={
                          activeRoute(route.path.toLowerCase())
                            ? activeColor
                            : textColor
                        }
                        fontWeight={
                          activeRoute(route.path.toLowerCase())
                            ? "bold"
                            : "normal"
                        }
                      >
                        {route.name}
                      </Text>
                    </Flex>
                    <Box
                      h="36px"
                      w="4px"
                      bg={
                        activeRoute(route.path.toLowerCase())
                          ? brandColor
                          : "transparent"
                      }
                      borderRadius="5px"
                    />
                  </HStack>
                )}
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
